exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.location-contact{display:flex;flex-direction:row;margin-top:16px}.location-contact__title{width:114px}.location-contact__contact{width:240px;margin-left:8px}.location-contact__contact .select-user-combo-box .display-box{background-color:#fff;border:1px solid #b8b8b8;border-radius:4px}.location-contact__contact .select-user-combo-box .display-box .selected-user-avatar{top:5px}.location-contact__contact .select-user-combo-box .display-box .selected-value{top:-3px}.location-contact__save{width:62px;height:22px;margin-top:17px;margin-left:8px;background-color:#fff;border:1px solid #4bb543;border-radius:4px;font-family:Open Sans,sans-serif;font-size:10px;font-weight:600;color:#4bb543;letter-spacing:0;line-height:22px;text-align:center;cursor:pointer}.location-contact__save--enabled{background-color:#4bb543;color:#fff}.location-contact__clear{cursor:pointer;margin-top:22px;margin-left:16px}.location-contact__clear img{height:16px;width:16px}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/containers/PORContainer/LocationCRUD/LocationContact/LocationContact.scss
// module id = 1759
// module chunks = 0